import React from 'react'
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';

function Success() {
  return (
    <>
    <HeaderBar />
    <Header />
    <h2>Thanks for your purchase!</h2>
    </>
  )
}

export default Success
